import { gql, useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { NOTIFICATION_TYPE, showNotification } from '@thinknet-gmbh/platform-common-ui';

import { GET_HEALTH_INSURANCE } from './get-health-insurance.hook';
import { GET_HEALTH_INSURANCE_BY_ID } from './get-health-insurance-by-id.hook';
import { GET_HEALTH_INSURANCE_BY_IDS } from './get-health-insurance-by-ids.hook';
import { GET_ALL_HEALTH_INSURANCE } from './get-all-health-insurance.hook';


export const DELETE_HEALTH_INSURANCE_BY_ID = gql`
  mutation deleteHealthInsuranceById($id: String!) {
    deleteHealthInsuranceById(id: $id) {
      _id
    }
  }
`;

export const useDeleteHealthInsuranceById = ({
  onSuccess,
}: {
  onSuccess: () => void;
}) => {
  const { t } = useTranslation('settings');
  const [deleteHealthInsuranceById] = useMutation(DELETE_HEALTH_INSURANCE_BY_ID, {
    onCompleted: data => {
      onSuccess();
      if (data?.deleteHealthInsuranceById?._id) {
        showNotification({
          isIcon: false,
          type: NOTIFICATION_TYPE.success,
          message: t('healthInsurance.notifications.deletedSuccessfully'),
        });
      }
    },
    onError: ({ graphQLErrors = [] }: { graphQLErrors?: any }) => {
      const [error] = graphQLErrors || [];

      return showNotification({
        isIcon: false,
        type: NOTIFICATION_TYPE.error,
        message: t('userProfileSettings.error.title'),
        description: error,
      });
    },
    refetchQueries: [
      GET_HEALTH_INSURANCE,
      GET_HEALTH_INSURANCE_BY_ID,
      GET_HEALTH_INSURANCE_BY_IDS,
      GET_ALL_HEALTH_INSURANCE
    ],
  });

  return deleteHealthInsuranceById;
};
